import React from "react"
import { ThemeColours } from "../../../../interfaces/pickers/ThemeColourPicker"


const getColourName = (value: ThemeColours) => Object.entries(ThemeColours).find(([, v]) => v === value)?.[0]


const ColourButton = ({ colour, setColour, isSelected}: {colour: ThemeColours, setColour: ()=>void, isSelected: boolean}) => {       
    const colourName = getColourName(colour)
     
    return (
        <button
            key={colour}
            className={`colour-button ${isSelected ? "selected" : ""}`}
            style={{ background: `#${colour}`}}
            onClick={setColour}
            aria-label={`Select ${colourName}`}
        />
    )
}

export default ColourButton
